export default __webpack_public_path__ + "locales/uk-UA/Notifications.json?hash=4b8bee4e7ac4871803b567ee143b640c";